import {
  MenuCoverPromotionType,
  MenuCoverPromotionTypeHelper,
  MenuCoverType,
  ModelType,
  VitrineCoverBlockType,
  VitrineCoverBottomBlockContent,
  VitrinePathwayBlockType,
} from '@biteinc/enums';
import { StringHelper } from '@biteinc/helpers';
import { menuCoverSchema } from '@biteinc/schemas';

app.MenuCover = app.AbstractModel.extend({
  ModelName: 'menuCover',
  Schema: menuCoverSchema,
  Type: ModelType.MenuCover,

  getFieldCollection(field, subProperty, _includeAllValues, _keyModel) {
    const fieldName = subProperty ? `${subProperty}.${field}` : field;
    switch (fieldName) {
      case 'menuCoverPromoIds':
      case 'promotion.menuCoverPromoIds':
      case 'portraitBlocks.menuCoverPromoIds':
      case 'portraitBlocks.pathways.menuCoverPromoIds':
        return app.menuCoverPromoList;
      case 'coverType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: MenuCoverType,
          nameGenerator: (name) => {
            switch (name) {
              case MenuCoverType.VitrineLandscape:
                return 'Vitrine Landscape';
              case MenuCoverType.VitrinePortrait:
                return 'Vitrine Portrait';
              case MenuCoverType.Gcn:
                return 'GCN';
            }
          },
        });
      case 'promotion.type':
      case 'portraitBlocks.promotionType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: MenuCoverPromotionType,
          nameGenerator: MenuCoverPromotionTypeHelper.name,
          values: MenuCoverPromotionTypeHelper.vitrineTypes,
        });
      case 'portraitBlocks.pathways.linkType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: VitrinePathwayBlockType,
          nameGenerator: (name) => {
            return name.split('_').map(StringHelper.toTitleCase).join(' ');
          },
        });
      case 'portraitBlocks.displayType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: MenuCoverPromotionType,
          nameGenerator: MenuCoverPromotionTypeHelper.name,
          values: MenuCoverPromotionTypeHelper.vitrineTypes,
        });
      case 'portraitBlocks.type':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: VitrineCoverBlockType,
          nameGenerator: (name) => {
            return name.split('_').map(StringHelper.toTitleCase).join(' ');
          },
        });
      case 'portraitBlocks.content':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: VitrineCoverBottomBlockContent,
          nameGenerator: (name) => {
            return StringHelper.toTitleCase(name);
          },
        });
    }
    return null;
  },
});
